import React, { useState, useEffect, useMemo } from 'react';
import Apicontext from './Contextapi';
import axios from 'axios';
import Swal from 'sweetalert2';
import Loading from './Loading';
import { API_BASE_URL } from '../apiConfig';
import {
  BRAND_NAME,
  META_DESCRIPTION,
  META_TITLE,
  SUPPORT_EMAIL,
  SUPPORT_PHONE_DISPLAY,
} from '../brandConfig';

const EMPTY_API_DATA = {
  detail: {
    title: BRAND_NAME,
    meta_title: META_TITLE,
    meta_description: META_DESCRIPTION,
    email: SUPPORT_EMAIL,
    primary_mobile: SUPPORT_PHONE_DISPLAY,
    logo: null,
    whatsapp: null,
    facebook: null,
  },
  college: [],
  counsellors: [],
  menu: [],
  subcategory: [],
  stream: [],
  prev_exam: [],
  exam: [],
  category: [],
  Country: [],
  State: [],
  religion: [],
  castecategory: [],
  blog: [],
  slider: [],
};

const getSettledData = (result, fallback = []) => {
  if (result.status === 'fulfilled') return result.value?.data ?? fallback;
  return fallback;
};

const Appprovider = ({ children }) => {
  const [apidata, setData] = useState('');
  const [loading, setLoading] = useState(true);
  const [APIdata, setApiData] = useState(EMPTY_API_DATA);
  const usertoken = localStorage.getItem('token');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoints = [
          `${API_BASE_URL}/site/site-config/`,
          `${API_BASE_URL}/college/all-college/`,
          `${API_BASE_URL}/counsellor/counsellor/`,
          `${API_BASE_URL}/college/category-colleges/`,
          `${API_BASE_URL}/general-setting/all_course_subcategory/`,
          `${API_BASE_URL}/general-setting/all_course_stream/`,
          `${API_BASE_URL}/exam/all-exam/`,
          `${API_BASE_URL}/exam/all-upcoming-exam/`,
          `${API_BASE_URL}/general-setting/all_course_category/`,
          `${API_BASE_URL}/main/country/`,
          `${API_BASE_URL}/main/state/?country_id=103`,
          `${API_BASE_URL}/main/religion/`,
          `${API_BASE_URL}/main/category/`,
          `${API_BASE_URL}/blog/all-blog/`,
          `${API_BASE_URL}/site/slider/`,
        ];

        const results = await Promise.allSettled(
          endpoints.map((url) => axios.get(url))
        );

        const failed = results
          .map((r, i) => ({ r, url: endpoints[i] }))
          .filter(({ r }) => r.status === 'rejected');

        if (failed.length) {
          console.warn(
            'Some API endpoints failed:',
            failed.map(({ url, r }) => ({
              url,
              status: r.reason?.response?.status,
              message: r.reason?.message,
            }))
          );
        }

        // All requests failed — show a soft error, keep empty safe defaults
        if (failed.length === results.length) {
          Swal.fire({
            icon: 'error',
            title: 'Oops, try again....',
            text: 'Server error',
          });
          setApiData(EMPTY_API_DATA);
          return;
        }

        const [
          Detailresponse,
          collegeResponse,
          counsres,
          menuResponse,
          subcategoryResponse,
          streamResponse,
          examResponse,
          up_examResponse,
          categoryResponse,
          countryResponse,
          stateResponse,
          religionres,
          castecategory,
          Blogresponse,
          sliderres,
        ] = results;

        const upcomingRaw = getSettledData(up_examResponse, []);
        const today = new Date();
        const filteredUpcomingExams = Array.isArray(upcomingRaw)
          ? upcomingRaw.filter((exam) => {
              const examDate = new Date(exam.exam_start_date);
              return examDate >= today;
            })
          : [];

        const detailData = getSettledData(Detailresponse, null);

        setApiData({
          detail: detailData && typeof detailData === 'object'
            ? {
                ...EMPTY_API_DATA.detail,
                ...detailData,
                title: detailData.title || BRAND_NAME,
                email: detailData.email || SUPPORT_EMAIL,
                primary_mobile:
                  detailData.primary_mobile || SUPPORT_PHONE_DISPLAY,
              }
            : EMPTY_API_DATA.detail,
          college: getSettledData(collegeResponse, []),
          counsellors: getSettledData(counsres, []),
          menu: getSettledData(menuResponse, []),
          subcategory: getSettledData(subcategoryResponse, []),
          stream: getSettledData(streamResponse, []),
          prev_exam: getSettledData(examResponse, []),
          exam: filteredUpcomingExams,
          category: getSettledData(categoryResponse, []),
          Country: getSettledData(countryResponse, []),
          State: getSettledData(stateResponse, []),
          religion: getSettledData(religionres, []),
          castecategory: getSettledData(castecategory, []),
          blog: getSettledData(Blogresponse, []),
          slider: getSettledData(sliderres, []),
        });
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops, try again....',
          text: 'Server error',
        });
        console.log('context Api error', error || 'An error occurred');
        setApiData(EMPTY_API_DATA);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [usertoken]);

  const updateData = React.useCallback((newData) => {
    setData(newData);
  }, []);

  const contextValue = useMemo(
    () => ({ apidata, APIdata, updateData }),
    [apidata, APIdata, updateData]
  );

  if (loading) {
    return <Loading />;
  }

  return (
    <Apicontext.Provider value={contextValue}>
      {children}
    </Apicontext.Provider>
  );
};

export default Appprovider;
